import React, { useEffect } from 'react';
import {
  SIGNUP_BUTTON_TITLE,
  clickScrollHandler,
  fixSubmenuHeight,
  handleScroll,
} from '~/utils/helpers';
import { GRID_BREAKPOINTS } from '~/utils/constants';

const NavHeader = ({ show_items, menu_src_override, location, menu_data }) => {
  let isHeightFixed = false;

  function handleWindowResize() {
    let isMobile = true;
    if (typeof window !== 'undefined') {
      isMobile = window.innerWidth < GRID_BREAKPOINTS.lg;
    }
    if (isMobile || isHeightFixed) {
      // no-op
      return;
    }
    isHeightFixed = true;
    fixSubmenuHeight();
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', handleWindowResize, false);
    }
  }

  function handleScrollToPosition(e, href) {
    const currentHref = href ? href : '#';
    if (currentHref?.startsWith('#') && currentHref !== '#') {
      handleScroll(e, currentHref);
    }
  }

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    handleWindowResize();

    window.addEventListener('resize', handleWindowResize, false);

    return () =>
      window.removeEventListener('resize', handleWindowResize, false);
  }, [menu_data]);

  return (
    <ul
      className={`${show_items ? 'menu-desktop' : 'menu-desktop menu-desktop--burgerless'}`}
    >
      {menu_data?.menu_items.map((data, index) => {
        let submenuItemsLvl1;
        let levelsNum = 0;

        // Submenu - Level 1
        if (
          show_items &&
          data.submenu_level_1 &&
          data.submenu_level_1.length > 0
        ) {
          levelsNum = 1;

          submenuItemsLvl1 = data.submenu_level_1.map(
            (submenuDataLvl1, index) => {
              let submenuItemsLvl2;
              let hasSubmenuLvl2 = false;
              if (
                submenuDataLvl1.submenu_level_2 &&
                submenuDataLvl1.submenu_level_2.length > 0
              ) {
                levelsNum = 2;
                hasSubmenuLvl2 = true;

                submenuItemsLvl2 = submenuDataLvl1.submenu_level_2.map(
                  (submenuDataLvl2, index) => {
                    let submenuItemsLvl3;
                    let hasSubmenuLvl3 = false;

                    if (
                      submenuDataLvl2.submenu_level_3 &&
                      submenuDataLvl2.submenu_level_3.length > 0
                    ) {
                      levelsNum = 3;
                      hasSubmenuLvl3 = true;

                      submenuItemsLvl3 = submenuDataLvl2.submenu_level_3.map(
                        (submenuDataLvl3, index) => {
                          return (
                            <li
                              key={index}
                              className={`item-level-3${submenuDataLvl3.class_name ? ' ' + submenuDataLvl3.class_name : ''} ${submenuDataLvl3.cta_style ? 'cta-style' : ''} ${index === 0 ? 'is-active' : ''}`}
                            >
                              <a
                                href={
                                  submenuDataLvl3.url
                                    ? submenuDataLvl3.url
                                    : '#'
                                }
                                onClick={e =>
                                  handleScrollToPosition(e, submenuDataLvl3.url)
                                }
                              >
                                {submenuDataLvl3.icon && (
                                  <div className='icon'>
                                    <img
                                      src={submenuDataLvl3.icon}
                                      alt={submenuDataLvl3.title}
                                      title={submenuDataLvl3.title}
                                    />
                                  </div>
                                )}
                                <div className='item-wr'>
                                  <div className='mtitle'>
                                    {submenuDataLvl3.title}
                                  </div>
                                  {submenuDataLvl3.description && (
                                    <p>{submenuDataLvl3.description}</p>
                                  )}
                                </div>
                              </a>
                            </li>
                          );
                        }
                      );
                    }

                    return (
                      <li
                        key={index}
                        className={`item-level-2${submenuDataLvl2.class_name ? ' ' + submenuDataLvl2.class_name : ''} ${submenuDataLvl2.cta_style ? 'cta-style' : ''} ${hasSubmenuLvl3 ? 'has-submenu' : ''} ${index === 0 ? 'is-active' : ''}`}
                      >
                        <a
                          href={submenuDataLvl2.url ? submenuDataLvl2.url : '#'}
                          onClick={e =>
                            handleScrollToPosition(e, submenuDataLvl2.url)
                          }
                        >
                          {submenuDataLvl2.icon && (
                            <div className='icon'>
                              <img
                                src={submenuDataLvl2.icon}
                                alt={submenuDataLvl2.title}
                                title={submenuDataLvl2.title}
                              />
                            </div>
                          )}
                          <div className='item-wr'>
                            <div className='mtitle'>
                              {submenuDataLvl2.title}
                            </div>
                            {submenuDataLvl2.description && (
                              <p>{submenuDataLvl2.description}</p>
                            )}
                          </div>
                        </a>
                        {submenuItemsLvl3 && (
                          <ul className='menu-level-3'>
                            <li className='submenu-title'>
                              {submenuDataLvl2.title}
                            </li>
                            {submenuItemsLvl3}
                          </ul>
                        )}
                      </li>
                    );
                  }
                );
              }

              return (
                <li
                  key={index}
                  className={`item-level-1${submenuDataLvl1.menu_class_name ? ' ' + submenuDataLvl1.menu_class_name : ''} ${submenuDataLvl1.cta_style ? 'cta-style' : ''} ${hasSubmenuLvl2 ? 'has-submenu' : ''} ${index === 0 ? 'is-active' : ''}`}
                >
                  <a
                    href={
                      submenuDataLvl1.submenu_url
                        ? submenuDataLvl1.submenu_url
                        : '#'
                    }
                    onClick={e =>
                      handleScrollToPosition(e, submenuDataLvl1.submenu_url)
                    }
                  >
                    {submenuDataLvl1.submenu_icon && (
                      <div className='icon'>
                        <img
                          src={submenuDataLvl1.submenu_icon}
                          alt={submenuDataLvl1.submenu_title}
                          title={submenuDataLvl1.submenu_title}
                        />
                      </div>
                    )}
                    <div className='item-wr'>
                      <div className='mtitle'>
                        {submenuDataLvl1.submenu_title}
                      </div>
                      {submenuDataLvl1.submenu_description && (
                        <p>{submenuDataLvl1.submenu_description}</p>
                      )}
                    </div>
                  </a>
                  {submenuItemsLvl2 && (
                    <ul className='menu-level-2'>
                      <li className='submenu-title'>
                        {submenuDataLvl1.submenu_title}
                      </li>
                      {submenuItemsLvl2}
                    </ul>
                  )}
                </li>
              );
            }
          );

          return (
            <li
              key={index}
              className={`has-submenu lvl-${levelsNum} ${data.menu_class_name ? ' ' + data.menu_class_name : ''} ${data.footer.text ? 'has-footer' : ''}`}
            >
              <a href='#'>
                {data.menu_title} <i className='fas fa-chevron-down'></i>
              </a>
              <ul className={`menu-level-1`}>
                <li className='submenu-title'>{data.menu_title}</li>
                {submenuItemsLvl1}
                <li className='submenu-footer'>
                  <div className='left'>{data.footer.text}</div>
                  <div className='right'>
                    <a href={data.footer.cta_url}>{data.footer.cta_text}</a>
                  </div>
                </li>
              </ul>
            </li>
          );
        }

        if (show_items || data.menu_title === SIGNUP_BUTTON_TITLE) {
          return (
            <li
              key={index}
              className={data.menu_class_name}
            >
              {menu_src_override !== 'scrolltop' && (
                <a
                  href={data.menu_url ? data.menu_url : '#'}
                  onClick={e => handleScrollToPosition(e, data.menu_url)}
                >
                  {data.menu_title}
                </a>
              )}
              {menu_src_override === 'scrolltop' && (
                <a
                  href='#'
                  onClick={clickScrollHandler}
                >
                  {data.menu_title}
                </a>
              )}
            </li>
          );
        }

        return undefined;
      })}
    </ul>
  );
};

export default NavHeader;
